<template>
  <div id="Opportunities_EnjoyingLa">
    <usc-hero class="mb" :title="this.hero.title" :loResSrc="this.hero.loResSrc" :hiResSrc="this.hero.hiResSrc" :color="this.page.color"></usc-hero>

    <usc-intro>
      <p slot="p">With Los Angeles’ fame as the world’s entertainment capital, it should come as no surprise that Southern California has more museums, theaters and music venues than any other U.S. city.</p>
    </usc-intro>

    <div class="body gutter-lg mb">
      <p><i>When you need a break from studying, you’ll enjoy countless ways to unwind and expand your cultural horizons. Whatever your interests, you’ll find it in Los Angeles.</i></p>
      <p>In Expo Park alone, right across the street from Marshall, explore the California Science Center (and the Space Shuttle Endeavor), the California African American Museum, the Natural History Museum of Los Angeles, Los Angeles Memorial Coliseum, BMO Stadium (for major league soccer) and Expo Park, with its beautiful, seven-acre rose garden. In Expo Park, you can also grab a Metro train to Santa Monica for shopping, a beach day and/or a visit to the iconic Santa Monica Pier.</p>
      <p>As one of the world’s most diverse cities, Los Angeles is a haven for foodies and gives you plentiful opportunities to celebrate different cultures. Visit Chinatown, Koreatown, Little Tokyo, Little Armenia, Thai Town, Little Ethiopia, Historic Filipinotown, Olvera Street — for authentic Mexican souvenirs and food — or numerous other enclaves. </p>
      <p>The <a href="https://ticketoffice.usc.edu/" class="inline-hyperlink" target="_blank">USC Ticket Office</a> sells discounted movie, theme park and other tickets to students. </p>
      <!-- <img src="../../../static/LA-attractions-copy.png" alt="LA Attractions" title="LA Attractions" style="width: 100%;"/> -->
    </div>
       <usc-datacard :data="this.dataVizCards">
        <h3 slot="title"></h3>
      </usc-datacard>

    <usc-statement :bg="this.page.color">
      <h2 slot="title">292 </h2>
      <p slot="paragraph">Enjoy 292 days of sunshine a year in Los Angeles, with 15 beaches, four mountain ranges, and plentiful parks and trails to explore.</p>
    </usc-statement>

    <div class="body gutter-lg mb">
      <h2>Here are just some of your leisure options in Los Angeles:</h2>
    </div>

    <usc-listImage>
        <h3 slot="title">Attractions and Landmarks</h3>
        <li slot="item">Disneyland</li>
        <li slot="item">Griffith Observatory</li>
        <li slot="item">Hollywood Walk of Fame</li>
        <li slot="item">Knott’s Berry Farm</li>
        <li slot="item">L.A. Live</li>
        <li slot="item">Los Angeles Zoo</li>
        <li slot="item">Paramount Pictures Studio Tour</li>
        <li slot="item">Santa Monica Pier</li>
        <li slot="item">Six Flags, Magic Mountain</li>
        <li slot="item">Sony Pictures Studio Tour</li>
        <li slot="item">Universal Studios Hollywood</li>
        <li slot="item">Venice Beach boardwalk</li>
        <li slot="item">Wizarding World of Harry Potter at Universal Studios</li>
        <li slot="item">Walt Disney Studio Tour</li>
        <li slot="item">Warner Bros. Studio Tour</li>
        <img slot="img" src="../../assets/Opportunities_EnjoyingLA_Attractions.jpg" alt="" />
    </usc-listImage>

    <usc-listImage>
        <h3 slot="title">Museums</h3>
        <li slot="item">Academy Museum of Motion Pictures</li>
        <li slot="item">Armand Hammer Museum</li>
        <li slot="item">Autry Museum of the American West</li>
        <li slot="item">The Broad</li>
        <li slot="item">The Geffen Contemporary at MOCA</li>
        <li slot="item">The Getty Villa</li>
        <li slot="item">J. Paul Getty Museum</li>
        <li slot="item">GRAMMY Museum</li>
        <li slot="item">The Huntington Library, Art Collections and Botanical Gardens</li>
        <li slot="item">La Brea Tar Pits and Museum</li>
        <li slot="item">Los Angeles County Museum of Art</li>
        <li slot="item">Museum of Contemporary Art (MOCA)</li>
        <li slot="item">Museum of Tolerance</li>
        <li slot="item">Natural History Museum of Los Angeles</li>
        <li slot="item">Norton Simon Museum</li>
        <li slot="item">Paley Center for Media</li>
        <li slot="item">Petersen Automotive Museum</li>
        <img slot="img" src="../../assets/Opportunities_EnjoyingLA_Museums.jpg" alt="" />
    </usc-listImage>

    <div class="body gutter-lg mb">
      <p><strong>The Lucas Museum of Narrative Art</strong><br />The pioneering Lucas Museum of Narrative Art will open in 2025 in Exposition Park, immediately south of the University Park Campus. Founded on the belief that visual storytelling can connect us and help shape a more just society, this education-focused museum will house the billion-dollar personal art collection of Founder and Chairman George Lucas, a USC alumnus. With a growing collection that encompasses artworks from across cultures, places, times and media — including paintings, sculptures, murals, photography, comic art, book and magazine illustrations and the arts of filmmaking — the Lucas Museum will explore narrative art’s potential to prompt questions, invite opinions, inspire community and move people to think about the impact of images on our world. An 11-acre campus with extensive new green space designed by Studio-MLA will embrace the museum’s 300,000-square-foot building, which will feature expansive galleries, two state-of-the-art theaters, and dedicated spaces for learning and engagement, dining, retail and events. The museum is being developed as a civic gift from Lucas and his wife, Mellody Hobson.</p>
    </div>
    <div class="gutter-md">
      <div class="usc-carousel__header">
        <div class="usc-carousel__title">Lucas Museum Concept Design</div>
        <div class="usc-carousel__nav">
          <div id="customize-controls" class="usc-carousel__controls">
            <button role="button" aria-label="Previous Image" @click="prevSlide" :disabled="prevDisabled" type="button" class="usc-carousel__button">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 13">
                <path fill="#231F20" d="M6 .5c0 .1 0 .2-.1.3L1.3 6.5l4.6 5.7c.1.3.1.6-.1.7-.3.1-.5.1-.7-.1L0 6.5 5.1.2c.2-.2.5-.2.7-.1.1.1.2.3.2.4z"/>
              </svg>
            </button>
            <button role="button" aria-label="Next Image" @click="nextSlide" :disabled="nextDisabled" type="button" class="usc-carousel__button">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 13">
                <path fill="#231F20" d="M0 12.5c0-.1 0-.2.1-.3l4.6-5.7L.1.8C0 .6 0 .3.2.1c.3-.1.5-.1.7.1L6 6.5.9 12.8c-.2.2-.5.3-.7.1-.1-.1-.2-.2-.2-.4z"/>
              </svg>
            </button>
          </div>
          <div class="usc-carousel__counter">
            {{this.slideIndex}} / {{this.totalSlides}}
          </div>
        </div>
      </div>
    </div>
    <div class="mb">
      <tiny-slider class="usc-carousel" :mouse-drag="false" :loop="false" items="1" :responsive="true" controlsContainer="#customize-controls">
        <div v-for="(slide, index) in this.slides" class="usc-carousel__slide">
          <!-- <div class="usc-carousel__img" :style="{ backgroundImage: 'url(' + slide.image + ')' }"></div> -->
          <div class="usc-carousel__outer">
            <img class="usc-carousel__inner" :src="slide.image" :alt="slide.alt || ''">
          </div>
        </div>
      </tiny-slider>
    </div>

    <usc-listImage>
        <h3 slot="title">Cinemas</h3>
        <li slot="item">Alamo Drafthouse Cinema (Downtown L.A.)</li>
        <li slot="item">AMC Century City 15</li>
        <li slot="item">AMC The Grove 14</li>
        <li slot="item">AMC Santa Monica</li>
        <li slot="item">ArcLight Hollywood</li>
        <li slot="item">Cinemark Playa Vista</li>
        <li slot="item">Egyptian Theatre</li>
        <li slot="item">El Capitan Theatre</li>
        <li slot="item">IMAX at California Science Center</li>
        <li slot="item">Landmark Nuart Theatre</li>
        <li slot="item">Regal Cinemas at L.A. Live</li>
        <li slot="item">Rooftop Cinema Club (Downtown L.A.)</li>
        <li slot="item">TLC Chinese Theatre</li>
        <li slot="item">Universal Cinema AMC at CityWalk Hollywood</li>
        <img slot="img" src="../../assets/Opportunities_EnjoyingLA_Movie_Theaters.jpg" alt=""/>
    </usc-listImage>

    <usc-listImage>
        <h3 slot="title">Concert Venues</h3>
        <li slot="item">Avalon Hollywood</li>
        <li slot="item">Conga Room at L.A. Live</li>
        <li slot="item">Crypto.com Arena</li>
        <li slot="item">Dolby Theatre</li>
        <li slot="item">El Rey Theatre</li>
        <li slot="item">Fonda Theatre</li>
        <li slot="item">Greek Theatre</li>
        <li slot="item">Kia Forum</li>
        <li slot="item">Peacock Theater at L.A. Live</li>
        <li slot="item">The Novo at L.A. Live</li>
        <li slot="item">Orpheum Theatre</li>
        <li slot="item">The Roxy Theatre</li>
        <li slot="item">SoFi Stadium</li>
        <li slot="item">Wiltern Theatre</li>
        <img slot="img" src="../../assets/Opportunities_EnjoyingLA_Pop_Venues.jpg" alt="" />
    </usc-listImage>

    <usc-listImage>
        <h3 slot="title">Shopping</h3>
        <li slot="item">Melrose Avenue: A popular place to shop and people watch, Melrose has a wide range of shops, cafés and restaurants.</li>
        <li slot="item">Third Street Promenade: This pedestrian-only street in Santa Monica features clothing boutiques, bookstores, movie theaters and restaurants.</li>
        <li slot="item">Rodeo Drive: Ground zero for designer boutiques, in famed Beverly Hills</li>
        <li slot="item">Malls: Among the most popular malls are Century City Shopping Center, Santa Monica Place, the Grove at Farmers Market and Universal CityWalk.</li>
        <img slot="img" src="../../assets/Opportunities_EnjoyingLA_Shopping.jpg" alt=""/>
    </usc-listImage>

    <usc-listImage>
        <h3 slot="title">Sports</h3>
        <li slot="item">Angel Stadium (Los Angeles Angels)</li>
        <li slot="item">BMO Stadium</li>
        <li slot="item">Crypto.com Center (Los Angeles Lakers, Clippers and Kings)</li>
        <li slot="item">Dodger Stadium (Los Angeles Dodgers)</li>
        <li slot="item">The Galen Center</li>
        <li slot="item">Kia Forum</li>
        <li slot="item">L.A. Memorial Coliseum</li>
        <li slot="item">SoFi Stadium (L.A. Rams)</li>
        <img slot="img" src="../../assets/Opportunities_EnjoyingLA_Sports.jpg" alt=""/>
    </usc-listImage>

    <usc-listImage>
        <h3 slot="title">Symphony/Opera</h3>
        <li slot="item">LA Opera</li>
        <li slot="item">The Music Center</li>
        <li slot="item">Walt Disney Concert Hall</li>
        <img slot="img" src="../../assets/Opportunities_EnjoyingLA_Symphony.jpg" alt=""/>
    </usc-listImage>

    <usc-listImage>
        <h3 slot="title">Theaters</h3>
        <li slot="item">Actors Forum Theatre</li>
        <li slot="item">Actors' Gang</li>
        <li slot="item">Ahmanson Theatre</li>
        <li slot="item">Alex Theatre</li>
        <li slot="item">The Broad Stage</li>
        <li slot="item">Dolby Theatre</li>
        <li slot="item">Geffen Playhouse</li>
        <li slot="item">Hudson Theatres</li>
        <li slot="item">Kirk Douglas Theatre</li>
        <li slot="item">Latino Theatre Co. at Los Angeles Theatre Center</li>
        <li slot="item">Mark Taper Forum</li>
        <li slot="item">Odyssey Theatre Ensemble</li>
        <li slot="item">Pantages Theatre</li>
        <li slot="item">Pasadena Playhouse</li>
        <li slot="item">Shakespeare Center of Los Angeles</li>
        <li slot="item">Wallis Annenberg Center for the Performing Arts</li>
        <li slot="item">Will Geer Theatricum Botanicum</li>
    </usc-listImage>

  </div>
</template>

<script>
import hero from '@/components/Hero'
import intro from '@/components/Intro'
import ListImage from '@/components/ListImage'
import Statement from '@/components/Statement'
import DataVizCards from '@/components/DataVizCards'
import VueTinySlider from 'vue-tiny-slider'

export default {
  name: 'EnjoyingLA',
  components: {
    'usc-hero': hero,
    'usc-intro': intro,
    'usc-listImage': ListImage,
    'usc-statement': Statement,
    'usc-datacard': DataVizCards,
    'tiny-slider': VueTinySlider
  },
  data () {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Enjoying Los Angeles',
        loResSrc: '../../../static/HeroImages/Marshall129.png',
        hiResSrc: '../../../static/HeroImages/Marshall129.png'
      },
      slideIndex: 1,
      vueTinySlider: VueTinySlider,
      prevDisabled: true,
      nextDisabled: false,
      slides: [
        {
          image: '/static/Opportunities_EnjoyingLA_1.jpg',
          alt: 'Lucas Museum of Narrative Art',
          id: 0
        },
        {
          image: '/static/Opportunities_EnjoyingLA_2.jpg',
          alt: 'Lucas Museum of Narrative Art',
          id: 1
        }
      ],
      dataVizCards: [
        {
          number: '577',
          subtext: 'Heritage & Historical Sites',
          img: './static/enjoyLA-heritage.png'
        },
        {
          number: '510',
          subtext: 'Live Music Venues',
          img: './static/enjoyLA-livemusic.png'
        },
        {
          number: '474',
          subtext: 'Book Shops',
          img: './static/enjoyLA-bookshops.png'
        },
        {
          number: '434',
          subtext: 'Art Galleries',
          img: './static/enjoyLA-artgalleries.png'
        },
        {
          number: '240',
          subtext: 'Public Libraries',
          img: './static/enjoyLA-publiclibraries.png'
        },
        {
          number: '231',
          subtext: 'Museums',
          img: './static/enjoyLA-museums.png'
        }
      ]
    }
  },
  created () {
    this.$root.setPageHeader('Opportunities', 'Enjoying Los Angeles')
  },
  methods: {
    prevSlide () {
      if (this.slideIndex > 1) {
        this.slideIndex--
      } else {
        this.prevDisabled = true
      }
    },
    nextSlide () {
      if (this.slideIndex < this.totalSlides) {
        this.slideIndex++
      } else {
        this.nextDisabled = true
      }
    }
  },

  computed: {
    totalSlides () {
      return this.slides.length
    }
  }
}
</script>

<style scoped lang="scss">
@import '~tiny-slider/src/tiny-slider';
img {
  width: 100%;
}
.statement {
  color: #000 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/advantages/EnjoyingLA.vue